import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { CampaignsDatePicker } from '@bingads-webui-campaign/campaigns-date-picker';
import { customizedInlineEditTemplate, convertMachineDateToUTCDate } from '@bingads-webui-campaign/summary-grid-helper';

export class DateInlineEditView extends DeterministicView {
  initialize({
    minDate, maxDate, selectedDate, allowNoDate, i18n, fieldName,
  }) {
    this.i18n = i18n;
    this.fieldName = fieldName;
    this.datePicker = new CampaignsDatePicker({
      minDate,
      maxDate,
      selectedDate,
      allowNoDate,
      noDateLabel: i18n.getString('noEndDate'),
      dateLabel: i18n.getString('EndBy'),
    });
    this.setChild('subEditView', this.datePicker);
  }

  get events() {
    return {
      'click .btn-primary': 'save',
      'click .btn-default': 'cancel',
      'click input[type=radio]': 'removeError',
    };
  }

  get template() {
    return ({ model }) => customizedInlineEditTemplate({ model, i18n: this.i18n });
  }

  save() {
    const date = this.datePicker.getSelectedDate();
    const isSelectCustomEndDate = this.$el.find('.date input[type=radio]').is(':checked');

    if (isSelectCustomEndDate && _.isNull(date)) {
      this.setErrors({
        EndDate: this.i18n.getString('Campaign_Validation_EndDateInvalid'),
        StartDate: this.i18n.getString('Campaign_Validation_StartDateInvalid'),
      });
      return;
    }

    this.trigger('save', {
      newSelectedDate: date ? convertMachineDateToUTCDate(date, this.i18n) : null,
    });
  }

  cancel() {
    this.trigger('close');
  }

  removeError() {
    this.setErrors({});
  }

  setErrors(errorMapping) {
    const errorContent = errorMapping && errorMapping[this.fieldName] ?
      errorMapping[this.fieldName] :
      '';
    if (errorContent.length > 0) {
      document.querySelectorAll('.grid-error-list').forEach(el => el.classList.remove('hide'));
    } else {
      document.querySelectorAll('.grid-error-list').forEach(el => el.classList.add('hide'));
    }
    // eslint-disable-next-line no-param-reassign
    document.querySelectorAll('.grid-error-message').forEach((el) => { el.innerHTML = errorContent; });
  }
}
